import { dew as _enumDew } from "./enum";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.enum_ = void 0;
  var enum_1 = _enumDew();
  Object.defineProperty(exports, "enum_", {
    enumerable: true,
    get: function () {
      return enum_1.enum_;
    }
  });
  return exports;
}